// extracted by mini-css-extract-plugin
export var wrapper = "main-module--wrapper--QwAKL";
export var headline = "main-module--headline--hw+hS";
export var actions = "main-module--actions--GcDMA";
export var fadein = "main-module--fadein--tC3JI";